import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-json-viewer',
  templateUrl: './irembogov-json-viewer.component.html',
  styleUrls: ['./irembogov-json-viewer.component.scss'],
})
export class IrembogovJsonViewerComponent {
  @Input() data: any;

  openMap = new Map<string, boolean>();

  isOpen(key: string): boolean {
    return this.openMap.get(key) ?? true;
  }

  toggle(key: string): void {
    this.openMap.set(key, !this.isOpen(key));
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object';
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  getType(value: any): string {
    if (value === null) {
      return 'null';
    }
    if (Array.isArray(value)) {
      return 'array';
    }
    return typeof value;
  }

  onKeyDown(event: KeyboardEvent, key: string) {
    const isEnterOrSpace = event.key === 'Enter' || event.key === ' ';
    if (isEnterOrSpace) {
      event.preventDefault(); // Prevent scrolling if space
      this.toggle(key);
    }
  }
}
